import React, { Component } from 'react';
import query from '../../common/sparql/index';
import {
    SPARQL_ENDPOINT
} from '../../common/constants';
import { Dropdown, Grid, Checkbox } from 'semantic-ui-react';
import * as _ from 'lodash';
import DeckGL , {ArcLayer} from 'deck.gl';
import {HexagonLayer} from '@deck.gl/aggregation-layers';
import {StaticMap} from 'react-map-gl';
import * as d3 from 'd3';
import * as dl from 'datalib';
import { queries } from '../../common/queries/index';
import Preloader from '../../components/Preloader';
import { CSVLink } from "react-csv";
import {strings} from '../../common/translations'

// const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoiZ2ltZW5lenhhdmkiLCJhIjoiY2l5azloMHh2MDAwdzJ3bnJvNzFjd2cyOCJ9.-5_OyNpfMYJ2HDV5GRMuYw";
const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoidGVjaC1kZXAtZnN0LWl0IiwiYSI6ImNrYjF4dXhvajAxNjgycXRiMGc0bTFpM3EifQ.5vMyu3Y9UIVy3YX_LGwt4g";
// const ALL = 'All';
// https://deck.gl/#/documentation/deckgl-api-reference/views/map-view
const initialMapViewState = {
  longitude: 11.2486,
  latitude: 43.7711,
  zoom: 6,
  pitch: 60,
  bearing: 0
};
const elevationScale = 25;
const elevationRange = [500, 2000];

const NUTS3ToscanaColorScale = d3.scaleOrdinal()
    .domain(['ITI11' , 'ITI12' , 'ITI13' , 'ITI14' , 'ITI15' , 'ITI16' , 'ITI17' , 'ITI18' , 'ITI19' , 'ITI1A'])
    .range([
        [166,206,227],
        [31,120,180],
        [178,223,138],
        [51,160,44],
        [251,154,153],
        [227,26,28],
        [253,191,111],
        [255,127,0],
        [202,178,214],
        [106,61,154]
    ]);

let NUTS3ToscanaRadiusScale = d3.scaleLinear().range([5000, 500000]);

// [lat,long] central coordinates for each Tuscany nuts3
const NUTS3ToscanaCentroidCoordinates = {
    'ITI11': [10, 44.3], // Massa and Carrara 
    'ITI12': [10.516667, 43.85], // Lucca
    'ITI13': [10.916667, 43.933333], // Pistoia
    'ITI14': [11.2542, 43.7714], // Firenze
    'ITI15': [11.096561, 43.880814], // Prato 
    'ITI16': [10.316667, 43.55], //Livorno 
    'ITI17': [10.4, 43.716667], //Pisa 
    'ITI18': [11.87, 43.473333], // Arezzo 
    'ITI19': [11.333333, 43.333333], //Siena
    'ITI1A': [11.108333, 42.75] // Grosseto
}

class DataVizErasmusPlus extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            organizationTypes: [],
            organizationTypesFilters: [],
            topics: [],
            topicsFilters: [],
            provinces: [
                { name: 'Massa and Carrara', checked: false, nuts3: 'ITI11' },
                { name: 'Lucca', checked: false, nuts3: 'ITI12' },
                { name: 'Pistoia', checked: false, nuts3: 'ITI13' },
                { name: 'Firenze', checked: false, nuts3: 'ITI14' },
                { name: 'Prato', checked: false , nuts3: 'ITI15'},
                { name: 'Livorno', checked: false, nuts3: 'ITI16' },
                { name: 'Pisa', checked: false, nuts3: 'ITI17' },
                { name: 'Arezzo', checked: false, nuts3: 'ITI18' },
                { name: 'Siena', checked: false, nuts3: 'ITI19' },
                { name: 'Grosseto', checked: false, nuts3: 'ITI1A' }
            ]
        };
        this.handleOrganizationTypeClick = this.handleOrganizationTypeClick.bind(this);
        this.handleTopicClick            = this.handleTopicClick.bind(this);
        this._onHover                    = this._onHover.bind(this);
        this._renderTooltip              = this._renderTooltip.bind(this);
    }

    async componentDidMount() {
        const organizationTypes = await query(
            SPARQL_ENDPOINT, 
            queries.participantsByOrgType
            );
        
        const topics = await query(
            SPARQL_ENDPOINT, 
            queries.projectsByTopic
        );
        
        // topic and org types come sorted by amount. Select by default
        // most occurrent topic, the first one        
        var data = await query(
            SPARQL_ENDPOINT,
            queries.projectsAndParticipants("Labour market issues incl. career guidance / youth unemployment")
        );

        this.setState({
            organizationTypes : organizationTypes,
            topics: topics,
            data: data,
            loadingMap: false,
            // firstTopic: _.first(topics).name,
            activeTopic: "Labour market issues incl. career guidance / youth unemployment"
        });
    }

    /**
     * 
     */
    _onHover({x, y, object}) {
        let arcs;

        if(_.isNil(object)) {
            const selectedNUTS3 = _.map(_.filter(this.state.provinces, 'checked'), 'nuts3');
            arcs = _.filter(
                this.state.data, 
                o => _.indexOf(selectedNUTS3, o.nuts3T) !== -1 
            )
        }
        else 
            arcs = object.points;

        this.setState({ x, y, arcs, hoveredCollaboration: object })
    }

    
    /**
     * 
     */
    _renderTooltip() {
        const {x, y, hoveredCollaboration} = this.state;

        if(hoveredCollaboration && hoveredCollaboration.points)
            return (                    
                <div className="tooltip" style={{left: x, top: y}}>
                    {hoveredCollaboration.points.length + " " + strings.ALTA_FORMAZIONE.CHARTS.MAP.TOOLTIP + " " + _.first(hoveredCollaboration.points).city}
                </div>
            );
    
    }



    /**
     * @param {SyntheticEvent} event 
     * @param {Object} data Array with the collection of selected values
     */
    handleOrganizationTypeClick(event, data) {     
        this.setState({
            organizationTypesFilters: data.value
        });
    }

    /**
     * @param {SyntheticEvent} event 
     * @param {Object} data selected topic value
     */
    handleTopicClick(event, data) {
        this.updateTopic(data);        
    }

    /**
     * 
     * @param {Object} data selected topic value
     */
    async updateTopic(data) {

        this.setState({
            loadingMap: true,
            activeTopic: data.value,
            // clean filter for org.type
            organizationTypesFilters: []
        })

        const result = await query(
            SPARQL_ENDPOINT,
            queries.projectsAndParticipants(data.value === '' ? this.state.activeTopic : data.value)
        );

        this.setState({
            loadingMap: false,
            topicsFilters: data.value,
            data: result
        });
    }



    render() {
        const { 
            organizationTypes,
            organizationTypesFilters,
            data,
            topics, 
            arcs, 
            loadingMap,
            activeTopic
        } = this.state;

        const organizationTypesOptions = _.map(
            organizationTypes,
            (organizationType, index) => ({
                key: index,
                text: organizationType.name, // + ' (' + organizationType.count + ')',
                value: organizationType.name,
            content: (<p className="m-0">{organizationType.name}</p>)
            })
        );

        const topicsOptions = _.map(
            topics,
            (topic, index) => ({
                key: index,
                text: topic.name,
                value: topic.name
            })
        );

        if(data) {            
            let filteredData = _.isEmpty(
                organizationTypesFilters
            )? data : _.filter(data, o => _.indexOf(organizationTypesFilters, o.orgTypeT) !== -1)

            // group by NUTS3 and add coords 
            const aggregateByNUTS3 = _.forEach(
                dl.groupby('nuts3T').execute(filteredData),
                o => { o.coordinates = NUTS3ToscanaCentroidCoordinates[o.nuts3T] }
            );
            // adjust the domain of the radius scale
            NUTS3ToscanaRadiusScale.domain(
                d3.extent(
                    aggregateByNUTS3,
                    o => o.values.length
                )
            );

            // build array of layers for the map
            const deckGLLayers = [
                new ArcLayer({
                    id: 'arc',
                    width: '100%',
                    height: '100%',
                    data: arcs,
                    getSourcePosition: d => {
                        return [d.lonT, d.latT];
                        /*return d.nuts3T ?
                            NUTS3ToscanaCentroidCoordinates[d.nuts3T] : 
                            [d.lonT, d.latT];*/
                    },
                    getTargetPosition: d => [d.lon, d.lat],
                    getSourceColor: d => 
                        // add some opacity in Toscana region
                        NUTS3ToscanaColorScale(d.nuts3T).concat([120]),
                    getWidth: 3,
                    getTargetColor: d => 
                        // add some opacity in Toscana region
                        NUTS3ToscanaColorScale(d.nuts3T).concat([120]),
                        onHover: this._onHover
                }),
                new HexagonLayer({
                    'id': 'hexagon-layer',
                    data: filteredData,
                    pickable: true,
                    getPosition: d => [d.lon, d.lat],
                    elevationRange: elevationRange,
                    elevationScale: elevationScale,
                    radius: 1000,   
                    extruded: true,
                    colorRange: [[34,94,168], [34,94,168], [37,52,148], [37,52,148], [8,29,88], [8,29,88]],
                    onHover: this._onHover
                })
            ].concat(
                // generate for each toscana province an hexagon layer
                NUTS3ToscanaColorScale.domain().map( (provinceCode, i) => {
                    return new HexagonLayer({
                        'id': 'hexagon-layer-' + i,
                        data: _.filter(filteredData, ['nuts3T', provinceCode]),
                        pickable: true,
                        getPosition: d => [d.lonT, d.latT],
                        elevationRange: elevationRange,
                        elevationScale: elevationScale,
                        radius: 500,  
                        extruded: true,
                        colorRange: new Array(6).fill(NUTS3ToscanaColorScale(provinceCode)),
                        onHover: this._onHover
                    })
                })
            );


            return (
                <Grid centered>
                    <Grid.Row centered>
                        <Dropdown
                            placeholder={strings.ALTA_FORMAZIONE.CHARTS.MAP.SELECTOR_INSTITUTION_PLACEHOLDER}
                            multiple
                            search
                            selection
                            options={organizationTypesOptions}
                            onChange={this.handleOrganizationTypeClick}
                            disabled={this.state.loadingMap}
                        />
                        <Dropdown
                            search
                            selection
                            options={topicsOptions}
                            onChange={this.handleTopicClick}
                            className='ml-2'
                            value={activeTopic}
                            disabled={this.state.loadingMap}
                        />
                    </Grid.Row>
                    {
                        loadingMap && <Preloader message={strings.COMMON.LOADING_DATA} />
                    }
                    {   (!loadingMap && filteredData.length > 0) ? <Grid.Row centered>
                            <div className='dataviz-erasmusplus'>                    
                                <div id="deckgl-wrapper">
                                    <DeckGL
                                        id="map"
                                        width={this.state.mapWidth}
                                        initialViewState={initialMapViewState}
                                        controller={true}
                                        height={600}
                                        layers={deckGLLayers}
                                        >
                                        <StaticMap
                                            reuseMaps
                                            mapboxApiAccessToken={MAPBOX_ACCESS_TOKEN} 
                                            // mapStyle="mapbox://styles/gimenezxavi/ck2yip55b0n091cqk6m764ul8"
                                            mapStyle="mapbox://styles/mapbox/light-v10"
                                            />
                                            {this._renderTooltip}
                                    </DeckGL>
                                    <div className='map-options-panel'>
                                        <div className="layout">
                                            {
                                                this.state.provinces.map( (province, i) => {
                                                    return <div className="wrapper" key={i}>
                                                        <div className={"legend-" + (i+1)}></div>
                                                        <Checkbox checked={province.checked} onClick={ (event, data) => {
                                                            // update selected provinces
                                                            let provinces = this.state.provinces;
                                                                provinces[i].checked = !provinces[i].checked;

                                                            // show only arcs pointing to 
                                                            // the selected provinces
                                                            const selectedNUTS3 = _.map(_.filter(provinces, 'checked'), 'nuts3');
                                                            const arcs = _.filter(
                                                                filteredData, 
                                                                o => _.indexOf(selectedNUTS3, o.nuts3T) !== -1 
                                                            );

                                                            this.setState({
                                                                provinces: provinces,
                                                                arcs: arcs
                                                            });
                                                        }}/>
                                                        <span>{province.name}</span>
                                                    </div>;
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>    
                            </div>
                            <Grid.Column width={16} className="d-flex flex-wrap pt-4 border-top">
                                <CSVLink data={data} 
                                         className="ui red circular icon button mx-auto"
                                         filename={"doveVanoErasmusToscana.csv"}>
                                             <i aria-hidden="true" className="download icon"></i>
                                </CSVLink>
                            </Grid.Column>
                        </Grid.Row>
                        :
                        <div className="emptystate">{strings.COMMON.NO_DATA}</div>
                    }                    
                </Grid>
                
            );
        }
        else
            return <Preloader message={strings.COMMON.LOADING_DATA} />
    }
}
export default DataVizErasmusPlus;